<template>
    <div>
<!--        <strong>{{ $_.get(activity, "actorUser.name") }}</strong> added a-->
<!--        <strong>{{ $_.get(activity, "payload.name") }}</strong> role.-->
        <span v-html="$t('notification.roleAdded', { user: $_.get(activity, 'actorUser.name'), role:$_.get(activity, 'payload.name') })"></span>
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "RoleAdded",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
});
</script>

<style scoped lang="scss"></style>
